"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
exports.updateMember = updateMember;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _uniq = _interopRequireDefault(require("lodash/uniq"));
var types = _interopRequireWildcard(require("./types"));
var _apis = require("./apis");
var _apis2 = require("../feeds/apis");
var _apis3 = require("../members/apis");
var _apis4 = require("../feedItems/apis");
var _apis5 = require("../users/apis");
var _selectors = require("../session/selectors");
var _selectors2 = require("./selectors");
var _actions = require("./actions");
var _actions2 = require("../notification/actions");
var _axios = require("axios");
var _selectors3 = require("../feeds/selectors");
var _selectors4 = require("../network/selectors");
var _middlewares = require("./middlewares");
var _middlewares2 = require("../network/middlewares");
var _actions3 = require("../websocket/actions");
var _api = require("../../utils/api");
var _types2 = require("../session/types");
var _constants = require("./constants");
var _schemas = require("./schemas");
var _constants2 = require("../app/constants");
var _uuid2 = require("../../utils/uuid");
var _time = require("../../utils/time");
var _types3 = require("../websocket/types");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _config = _interopRequireDefault(require("../../config"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
var _peerManager = _interopRequireDefault(require("../../utils/peerManager"));
var _streamManager = _interopRequireDefault(require("../../utils/streamManager"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _logger.default('saga:rooms');
function* waitAfterWS(_room, source) {
  logger.log('waitAfterWS', {
    _room,
    source
  });
  var isWsLaunchable = yield (0, _effects.select)(_selectors4.getIsWsCanLaunchSelector);
  if (isWsLaunchable) {
    _callbacks.default.get('onRoomWSNotConnected')(_room);
    yield (0, _effects.put)((0, _actions3.launchWebsocket)());
    logger.log('launchWebsocket -- waitAfterWS');
    yield (0, _effects.take)(_types3.WS_CONNECT);
  }
  return true;
}
function localStreamLogic(_ref) {
  var {
    audio,
    video,
    screen,
    _client,
    _room
  } = _ref;
  return function* () {
    logger.log('localStreamLogic', {
      audio,
      video,
      screen,
      _client,
      _room
    });
    if (!_client) {
      _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    }
    yield (0, _effects.call)(_streamManager.default.getLocalStream, {
      _client,
      audio,
      video,
      screen,
      _entity: _room
    });
  }();
}
function* ringingStop(_room) {
  try {
    logger.log('ringingStop', {
      _room
    });
    _callbacks.default.get('DeviceCallManagerStopRingtone')({
      _room
    });
    yield (0, _effects.put)((0, _actions.removeRingingRooms)([_room]));
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e, 'ringingStop');
  }
}
function ringingStopScheduler(_ref2) {
  var {
    duration,
    _room
  } = _ref2;
  return function* () {
    try {
      logger.log('ringingStopScheduler', {
        _room,
        duration
      });
      yield (0, _effects.delay)(duration);
      yield (0, _effects.call)(ringingStop, _room);
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'ringingStopScheduler');
    }
  }();
}
function ringingLogic(_ref3) {
  var {
    duration = _config.default.webRTC.defaultRingingDuration,
    _room,
    enable = false
  } = _ref3;
  return function* () {
    try {
      logger.log('ringingLogic', {
        duration,
        _room,
        enable
      });
      if (!_room) return;
      var _ringingRooms = yield (0, _effects.select)(_selectors2.getRingingRoomsSelector);
      var _currentByClientRooms = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);
      var isAlreadyRingingOrJoined = _ringingRooms.includes(_room) || _currentByClientRooms.includes(_room);
      if (enable && !isAlreadyRingingOrJoined && duration > 0) {
        logger.debug('ringingLogic addRingingRooms');
        yield (0, _effects.spawn)(ringingStopScheduler, {
          duration,
          _room
        });
        yield (0, _effects.put)((0, _actions.addRingingRooms)([_room]));
        var _currentByClient = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);
        if (_callbacks.default.isExist('DeviceCallManagerStartRingtone')) {
          _callbacks.default.get('DeviceCallManagerStartRingtone')({
            multiCall: _ringingRooms.length > 0 || _currentByClient.length > 0,
            _room
          });
        }
      }
      if (duration <= 0 || !enable && isAlreadyRingingOrJoined) {
        yield (0, _effects.call)(ringingStop, _room);
      }
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'ringingLogic');
    }
  }();
}
function* removeCurrentRoomByClientLogic(_room) {
  if (!_room) return;
  var _currentByClient = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);
  if (_currentByClient.includes(_room)) {
    yield (0, _effects.put)((0, _actions.removeCurrentRoomsByClient)([_room]));
    _callbacks.default.get('DeviceCallManagerStop')({
      _room
    });
    try {
      _peerManager.default.removePeersByEntity(_room);
      _streamManager.default.removeStreamsByEntity(_room);
    } catch (e) {
      logger.warn('removeCurrentRoomByClientLogic', e);
    }
  }
}
function* addCurrentRoomsByClientLogic(_room) {
  if (!_room) return;
  var _currentByClient = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);
  // check if room is still in entities to avoid race (delete when acceptIncoming)
  var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
  if (room && !_currentByClient.includes(_room)) {
    yield (0, _effects.put)((0, _actions.addCurrentRoomsByClient)([_room]));
  }
}
function* removeCurrentRoomsByUserLogic(_room) {
  if (!_room) return;
  var _currentUserRooms = yield (0, _effects.select)(_selectors2.getCurrentByUserRoomsSelector);
  if (_currentUserRooms.includes(_room)) {
    yield (0, _effects.put)((0, _actions.removeCurrentRoomsByUser)([_room]));
  }
}
function* addCurrentRoomsByUserLogic(_room) {
  if (!_room) return;
  var _currentUserRooms = yield (0, _effects.select)(_selectors2.getCurrentByUserRoomsSelector);
  if (!_currentUserRooms.includes(_room)) {
    yield (0, _effects.put)((0, _actions.addCurrentRoomsByUser)([_room]));
  }
}
function getRooms(_ref4) {
  var {
    type
  } = _ref4;
  return function* () {
    logger.log('getRooms');
    if (type === _types3.WS_CONNECT && !_config.default.room.fetchOnWsReload) {
      return;
    }
    try {
      var response = yield (0, _effects.call)(_apis.$getRooms);
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      var rooms = [];
      for (var room of response.data) {
        // sequential to avoid calling multiple search contacts on the same caller
        var roomEnriched = yield (0, _middlewares.roomEnrichment)({
          room,
          _client,
          _user
        });
        rooms.push(roomEnriched);
      }

      // TODO: if incoming from the background, the getRooms should exec after the room incoming recvd
      var _currentByClient = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);
      if (_currentByClient.length) {
        for (var _room of _currentByClient) {
          var _room2 = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
          rooms.push(_room2);
        }
      }
      if (rooms !== null && rooms !== void 0 && rooms.length) {
        var _rooms = yield* (0, _api.normalizeApiResponse)(rooms, [_schemas.room]);
        yield (0, _effects.put)((0, _actions.setRooms)(_rooms));
      } else {
        yield (0, _effects.put)((0, _actions.setRooms)([]));
      }
    } catch (e) {
      if ((0, _middlewares2.isNetworkError)(e)) return;
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'R1',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getRooms');
    }
  }();
}
function getRoom(_ref5) {
  var {
    _room
  } = _ref5;
  return function* () {
    logger.log('getRoom', {
      _room
    });
    try {
      var response = yield (0, _effects.call)(_apis.$getRoom, _room);
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      var roomEnriched = yield (0, _effects.call)(_middlewares.roomEnrichment, {
        room: response.data,
        _client,
        _user
      });
      var _rooms = yield* (0, _api.normalizeApiResponse)([roomEnriched], [_schemas.room]);
      yield (0, _effects.put)((0, _actions.addRooms)(_rooms));
      return roomEnriched;
    } catch (e) {
      var _e$response, _e$response2;
      if ((0, _middlewares2.isNetworkError)(e)) return;
      if (e instanceof _axios.AxiosError && (e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 403 && _callbacks.default.isExist('onRoomForbidden')) {
        _callbacks.default.get('onRoomForbidden')(_room);
      } else if (e instanceof _axios.AxiosError && (e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) === 404) {
        _callbacks.default.get('onRoomNotFound')(_room);
      } else {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'R2',
          error: e
        }));
      }
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getRoom');
      return undefined;
    }
  }();
}
function handleWsRoomUpdate(_ref6) {
  var {
    payload
  } = _ref6;
  return function* () {
    logger.log('handleWsRoomUpdate', {
      payload
    });
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    var _user = yield (0, _effects.select)(_selectors.getUserId);
    var nextRoom = _objectSpread({}, payload);
    var prevRoom = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, payload.id);
    if (prevRoom) {
      nextRoom.forcedDisplayMode = prevRoom.forcedDisplayMode;
      logger.debug('handleWsRoomUpdate:displayMode set forcedDisplayMode to', prevRoom.forcedDisplayMode);
      nextRoom.displayMode = prevRoom.displayMode;
      logger.debug('handleWsRoomUpdate:displayMode set to ', prevRoom.displayMode);
      nextRoom.focusOn = prevRoom.focusOn;
      logger.debug('handleWsRoomUpdate:focusOn set to ', prevRoom.focusOn);
    } else {
      nextRoom.forcedDisplayMode = null;
      nextRoom.displayMode = null;
      nextRoom.focusOn = null;
      logger.debug('handleWsRoomUpdate: no previous room');
    }

    // if (!prevRoom && nextRoom.isPersistent === false && !isNil(nextRoom.ringingDuration)) {
    //     // Synchronize the local time with the backend time to make clock synced.
    //     // In case of network cutting (and missed events) client should automatically
    //     // and synchronously stop ringing with the backend.
    //     duration = websocketClockSync(nextRoom.startedAt) - Date.now() + nextRoom.ringingDuration;
    //     logger.debug('handleWsRoomUpdate startTest', duration);
    // } else {
    //     logger.debug('handleWsRoomUpdate startTest NO');
    // }

    // stop ringing logic in case room has been changed to a persisted room
    if ((prevRoom === null || prevRoom === void 0 ? void 0 : prevRoom.isPersistent) === false && nextRoom.isPersistent === true) {
      logger.debug('handleWsRoomUpdate room is now persistent, will stop ringing', nextRoom.isPersistent);
      yield (0, _effects.call)(ringingLogic, {
        _room: nextRoom.id,
        enable: false
      });
    }
    var roomEnriched = yield (0, _effects.call)(_middlewares.roomEnrichment, {
      room: nextRoom,
      _client,
      _user
    });
    var membersDiff = (0, _middlewares.membersDifference)(prevRoom, roomEnriched);
    var prevUpdatedAt = prevRoom ? new Date(prevRoom.updatedAt).getTime() : 0;
    var roomEnrichedUpdatedAt = new Date(roomEnriched.updatedAt).getTime();
    if (!prevRoom || membersDiff.isMembersChanged && prevUpdatedAt === roomEnrichedUpdatedAt ||
    // race happened, should save the next state (hope it s the right one)
    prevUpdatedAt < roomEnrichedUpdatedAt) {
      yield* (0, _api.normalizeApiResponse)([roomEnriched], [_schemas.room]);
    } else {
      logger.warn('handleWsRoomUpdate: WS_ROOM_UPDATE is outdated, skip event', prevRoom, nextRoom);
    }
    if (membersDiff.isMyClientJoined) {
      var _roomEnriched$focusOn, _roomEnriched$focusOn2, _roomEnriched$focusOn3;
      var iAmJoining = membersDiff.joined.includes(_client) ? 1 : 0;
      if (membersDiff.joined.length - iAmJoining > 0) {
        _callbacks.default.get('ActionWhenMemberJoined')();
        if (roomEnriched.caller.isMe) {
          _callbacks.default.get('DeviceCallManagerStopRingback')();
        }
      }
      if (membersDiff.left.length) {
        _callbacks.default.get('ActionWhenMemberLeft')();
        if (roomEnriched.caller.isMe && roomEnriched.members.length === 1) {
          _callbacks.default.get('DeviceCallManagerStopRingback')();
        }
      }
      if ((membersDiff.left.includes((_roomEnriched$focusOn = roomEnriched.focusOn) === null || _roomEnriched$focusOn === void 0 ? void 0 : _roomEnriched$focusOn._user) || membersDiff.kicked.includes((_roomEnriched$focusOn2 = roomEnriched.focusOn) === null || _roomEnriched$focusOn2 === void 0 ? void 0 : _roomEnriched$focusOn2._user)) && [_constants.USER_IN_ROOM_STATUS.LEFT, _constants.USER_IN_ROOM_STATUS.KICKED].includes((_roomEnriched$focusOn3 = roomEnriched.focusOn) === null || _roomEnriched$focusOn3 === void 0 ? void 0 : _roomEnriched$focusOn3.status)) {
        var _nextFocus;
        // check if focus is still in the room
        // find a member is not me and joined?
        var nextFocus = roomEnriched.members.find(_ref7 => {
          var {
            isMe,
            status
          } = _ref7;
          return !isMe && (0, _middlewares.isJoinedOrHoldMember)(status);
        });
        if (!nextFocus) {
          // find a member is not me and waiting state?
          nextFocus = roomEnriched.members.find(_ref8 => {
            var {
              isMe,
              status
            } = _ref8;
            return !isMe && status === _constants.USER_IN_ROOM_STATUS.WAITING;
          });
        }
        if ((_nextFocus = nextFocus) !== null && _nextFocus !== void 0 && _nextFocus._client) {
          yield (0, _effects.call)(setFocusOnClient, {
            _client: nextFocus._client,
            _room: roomEnriched.id
          });
        }
      }
    }
    var _room = payload.id;
    var _rooms = yield (0, _effects.select)(_selectors2._roomsSelector);
    if (!_rooms.includes(_room)) {
      yield (0, _effects.put)((0, _actions.addRooms)([_room]));
    }
    if (!membersDiff.isMyClientJoined) {
      var _currentByClient = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);

      // not in members and found this room in _room
      // was in
      if (_currentByClient.includes(_room) && !membersDiff.isMyUserWaiting) {
        yield (0, _effects.fork)(handleWsRoomEnd, {
          payload: roomEnriched
        });
      }
      if (!membersDiff.isMyUserJoined) {
        yield (0, _effects.call)(removeCurrentRoomsByUserLogic, _room);
      } else {
        if (membersDiff.isMyUserJoined || membersDiff.isMyUserWaiting) {
          yield (0, _effects.call)(addCurrentRoomsByUserLogic, _room);
        } else {
          yield (0, _effects.call)(removeCurrentRoomsByUserLogic, _room);
        }
      }
    } else {
      yield (0, _effects.call)(addCurrentRoomsByClientLogic, _room);
    }
  }();
}
function handleWsRoomDelete(_ref9) {
  var {
    payload: {
      id: _room
    }
  } = _ref9;
  return function* () {
    logger.log('handleWsRoomDelete', {
      _room
    });
    yield (0, _effects.call)(ringingLogic, {
      _room,
      enable: false
    });
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    var _user = yield (0, _effects.select)(_selectors.getUserId);
    var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
    if (room) {
      var roomEnriched = yield (0, _effects.call)(_middlewares.roomEnrichment, {
        room,
        _client,
        _user
      });
      yield (0, _effects.call)(handleWsRoomEnd, {
        payload: roomEnriched
      });
      var _roomsBis = yield (0, _effects.select)(_selectors2._roomsSelector);
      if (_roomsBis.includes(_room)) {
        yield (0, _effects.put)((0, _actions.removeRoom)(_room));
      }
    }
  }();
}
function* getFeedInfosFromRoomFeed(_feed, roomMembers) {
  if (!_feed) return {
    displayRoomEndWithFeedContent: false
  };
  try {
    var feed = yield (0, _effects.select)(_selectors3.feedByIdSelector, _feed);
    var feedName;

    /* Get feed name */
    if (feed) {
      var {
        name,
        cast
      } = feed;
      if (cast === 1) return {
        displayRoomEndWithFeedContent: false
      };
      feedName = name;
    } else {
      var {
        data: feedData
      } = yield (0, _effects.call)(_apis2.$getFeed, _feed);
      if (feedData.cast === 1) return {
        displayRoomEndWithFeedContent: false
      };
      feedName = feedData.name;
    }

    /* Get feed members infos */
    var {
      data: feedMembersData
    } = yield (0, _effects.call)(_apis3.$getFeedMembers, _feed);
    var _roomMembers = (0, _uniq.default)(roomMembers.map(e => e._user)).sort();
    var _feedMembers = feedMembersData.map(e => {
      var _e$user;
      return e === null || e === void 0 || (_e$user = e.user) === null || _e$user === void 0 ? void 0 : _e$user.id;
    }).sort();
    var areRoomMembersExactlyFeedMembers = (0, _isEqual.default)(_roomMembers, _feedMembers);
    return {
      feedName,
      displayRoomEndWithFeedContent: areRoomMembersExactlyFeedMembers
    };
  } catch (e) {
    return {
      displayRoomEndWithFeedContent: false
    };
  }
}
function handleWsRoomEnd(_ref10) {
  var {
    payload: room
  } = _ref10;
  return function* () {
    try {
      var _config$room, _config$room2, _config$room3, _config$room4;
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      var delayBeforeDestroy = (_config.default === null || _config.default === void 0 || (_config$room = _config.default.room) === null || _config$room === void 0 ? void 0 : _config$room.displayEndedCallDuration) || 5000;
      var _room = room.id;
      var _currentByClient = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);
      var roomEnriched = yield (0, _effects.call)(_middlewares.roomEnrichment, {
        room,
        _client,
        _user
      });
      logger.log('handleWsRoomEnd', {
        roomEnriched,
        delayBeforeDestroy
      });
      var displayRoomEnd = _currentByClient.includes(_room);
      if (!((_config$room2 = _config.default.room) !== null && _config$room2 !== void 0 && _config$room2.displayRoomEndIfPersistent)) displayRoomEnd = displayRoomEnd && !roomEnriched.isPersistent;
      if (!((_config$room3 = _config.default.room) !== null && _config$room3 !== void 0 && _config$room3.displayRoomEndIfNoMembersInvited)) {
        var uniqMembers = (0, _uniq.default)(roomEnriched.members, '_user');
        displayRoomEnd = displayRoomEnd && uniqMembers.length > 1;
      }
      if (displayRoomEnd) {
        var _Callbacks$get;
        var endedRoom = _objectSpread(_objectSpread({}, roomEnriched), {}, {
          stopDisplayAt: new Date(Date.now() + delayBeforeDestroy).toISOString(),
          displayRoomEndWithFeedContent: false
        });
        if (roomEnriched._sourceFeed) {
          var {
            feedName,
            displayRoomEndWithFeedContent
          } = yield (0, _effects.call)(getFeedInfosFromRoomFeed, roomEnriched._sourceFeed, roomEnriched.members);
          endedRoom.feedName = feedName;
          endedRoom.displayRoomEndWithFeedContent = displayRoomEndWithFeedContent;
        }
        delete endedRoom.focusOn;
        delete endedRoom.myStream;
        yield (0, _effects.put)((0, _actions.addEndedRoom)([endedRoom]));
        yield (0, _effects.call)(removeCurrentRoomByClientLogic, _room);
        var clientSource = (_Callbacks$get = _callbacks.default.get('getSource')()) !== null && _Callbacks$get !== void 0 ? _Callbacks$get : 'web';

        // why this on mobile ? very strange, once room is ended, how it can be unended ?
        if (clientSource !== 'web') {
          var {
            timeout
          } = yield (0, _effects.race)({
            cancel: (0, _effects.take)(types.ROOM_ENDED_CANCEL_REMOVE),
            timeout: (0, _effects.delay)(delayBeforeDestroy)
          });
          if (timeout) yield (0, _effects.put)((0, _actions.removeEndedRoom)([_room]));
        }
      } else {
        yield (0, _effects.call)(removeCurrentRoomByClientLogic, _room);
      }
      if ((_config$room4 = _config.default.room) !== null && _config$room4 !== void 0 && _config$room4.autoUnHoldAtRoomEnd) {
        // looking for a room in hold state
        var [holdRoom] = yield (0, _effects.select)(_selectors2.getHoldRoomSelector);
        if (holdRoom !== null && holdRoom !== void 0 && holdRoom.id) {
          logger.log('autoUnHoldAtRoomEnd next room', {
            holdRoom
          });
          yield (0, _effects.call)(holdRoomLogic, {
            _room: holdRoom.id,
            hold: false,
            triggeredBy: 'handleWsRoomEnd'
          });
        }
      }
    } catch (e) {
      logger.warn('handleWsRoomEnd', e);
    }
  }();
}
function wsRoomIncoming(_ref11) {
  var {
    payload
  } = _ref11;
  return function* () {
    logger.log('wsRoomIncoming', {
      payload
    });
    if (!payload) return;
    // should be removed when ROOM_INCOMING will always send an array
    var incomingRooms = Array.isArray(payload) ? payload : [payload];
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    var _user = yield (0, _effects.select)(_selectors.getUserId);
    var rooms = [];

    // in order to gain sec to add room in redux, we cut the enrichment in 2 steps,
    // first without searchContact, second with it
    for (var room of incomingRooms) {
      // sequential to avoid calling multiple search contacts on the same caller
      var roomEnriched = yield (0, _middlewares.roomEnrichment)({
        room,
        _client,
        _user,
        searchContact: false
      });
      var prevRoom = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, roomEnriched.id);
      if (!prevRoom || new Date(prevRoom.updatedAt) < new Date(roomEnriched.updatedAt)) {
        rooms.push(roomEnriched);
      }
    }
    if (rooms.length) {
      yield* (0, _api.normalizeApiResponse)(rooms, [_schemas.room]);
    }

    // Add ringing rooms
    for (var _room3 of rooms) {
      var duration = void 0;
      if (!(0, _isNil.default)(_room3.ringingDuration)) {
        // Synchronize the local time with the backend time to make clock synced.
        // In case of network cutting (and missed events) client should stop ringing
        // synchronously with the backend.
        // # For mobile
        // if call is from notification and app not started or foreground,
        // WS is not started, all events for deleting room and trigger
        // stopRingback are not received.
        // This, is a security to stop room event WS is not started
        duration = (0, _time.websocketClockSync)(_room3.startedAt) - Date.now() + _room3.ringingDuration;
      }
      yield (0, _effects.call)(ringingLogic, {
        _room: _room3.id,
        enable: true,
        duration
      });
    }

    // request localStreams after ringing to display the modal as soon as possible
    var _currentByClient = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);

    // on rn webrtc if a second stream is requested , the tracks of the first one are muted
    if (_config.default.requestLocalStreamAtWsRoomIncoming && !(_currentByClient !== null && _currentByClient !== void 0 && _currentByClient.length)) {
      var roomsUpdated = [];
      for (var _room4 of incomingRooms) {
        yield (0, _effects.call)(localStreamLogic, {
          _client,
          video: _room4.isVideoCall,
          audio: true,
          _room: _room4.id
        });

        // sequential to avoid calling multiple search contacts on the same caller
        var _roomEnriched = yield (0, _middlewares.roomEnrichment)({
          room: _room4,
          _client,
          _user
        });
        var _prevRoom = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _roomEnriched.id);

        // could be a race if roomUpdate is received before the roomEnriched finished
        if (!_prevRoom || new Date(_prevRoom.updatedAt) < new Date(_roomEnriched.updatedAt)) {
          roomsUpdated.push(_roomEnriched);
        } else {
          roomsUpdated.push(_prevRoom);
        }
      }
      if (roomsUpdated.length) {
        yield* (0, _api.normalizeApiResponse)(roomsUpdated, [_schemas.room]);
      }
    }

    // try to fetch info on caller
    for (var _room5 of incomingRooms) {
      // sequential to avoid calling multiple search contacts on the same caller
      var _roomEnriched2 = yield (0, _middlewares.roomEnrichment)({
        room: _room5,
        _client,
        _user
      });
      var _prevRoom2 = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _roomEnriched2.id);
      if (!_prevRoom2 || new Date(_prevRoom2.updatedAt) < new Date(_roomEnriched2.updatedAt)) {
        rooms.push(_roomEnriched2);
      }
    }
    if (rooms.length) {
      yield* (0, _api.normalizeApiResponse)(rooms, [_schemas.room]);
    }
  }();
}
var holdRoomStates = {};
function holdRoomLogic(_ref12) {
  var {
    _room,
    hold,
    triggeredBy
  } = _ref12;
  return function* () {
    logger.log('holdRoomLogic', {
      _room,
      hold,
      triggeredBy
    });
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    holdRoomStates[_room] = hold;
    if (hold) {
      _streamManager.default.mute({
        _client,
        kind: 'audio',
        _entity: _room
      });
      _streamManager.default.mute({
        _client,
        kind: 'video',
        _entity: _room
      });
      _streamManager.default.muteAllRemoteTracks({
        kind: 'audio',
        _entity: _room
      });
    } else {
      _streamManager.default.unmuteAllRemoteTracks({
        kind: 'audio',
        _entity: _room
      });
    }
    try {
      yield (0, _effects.call)(waitAfterWS, _room, 'holdRoomLogic');
      var {
        data
      } = yield (0, _effects.call)(_apis.$patchRoomJoin, _room, _client, undefined, undefined, undefined, hold, triggeredBy);
      if (data.audio) {
        _streamManager.default.unmute({
          _client,
          kind: 'audio',
          _entity: _room
        });
      } else {
        _streamManager.default.mute({
          _client,
          kind: 'audio',
          _entity: _room
        });
      }
      if (data.video) {
        _streamManager.default.unmute({
          _client,
          kind: 'video',
          _entity: _room
        });
      } else {
        _streamManager.default.mute({
          _client,
          kind: 'video',
          _entity: _room
        });
      }
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'holdRoom');
      _callbacks.default.get('onHoldRoomFailed')(_room, hold);
    }
  }();
}
function patchRoomJoin(_ref13) {
  var {
    _room,
    audio,
    video: camera,
    screenSharing,
    triggeredBy
  } = _ref13;
  return function* (_Callbacks$get2) {
    logger.log('patchRoomJoin', {
      _room,
      audio,
      camera,
      screenSharing,
      triggeredBy
    });
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    if ((0, _isNil.default)(audio) && (0, _isNil.default)(camera) && (0, _isNil.default)(screenSharing)) return;
    var currentAudio = yield (0, _effects.call)(_streamManager.default.hasAudio, {
      _client,
      _entity: _room
    });
    var currentCamera = yield (0, _effects.call)(_streamManager.default.hasCamera, {
      _client,
      _entity: _room
    });
    var currentScreen = yield (0, _effects.call)(_streamManager.default.hasScreen, {
      _client,
      _entity: _room
    });
    var audioExpected = (0, _isNil.default)(audio) ? currentAudio : audio;
    var cameraExpected = (0, _isNil.default)(camera) ? currentCamera : camera;
    var screenExpected = (0, _isNil.default)(screenSharing) ? currentScreen : screenSharing;
    var clientSource = (_Callbacks$get2 = _callbacks.default.get('getSource')()) !== null && _Callbacks$get2 !== void 0 ? _Callbacks$get2 : 'web';
    try {
      if (currentAudio && !audioExpected) {
        yield (0, _effects.call)(_streamManager.default.mute, {
          _client,
          kind: 'audio',
          _entity: _room
        });
      } else if (!currentAudio && audioExpected) {
        yield (0, _effects.call)(_streamManager.default.unmute, {
          _client,
          kind: 'audio',
          _entity: _room
        });
      }
      if (currentCamera && !cameraExpected) {
        yield (0, _effects.call)(_streamManager.default.mute, {
          _client,
          kind: 'camera',
          _entity: _room
        });
      } else if (!currentCamera && cameraExpected) {
        yield (0, _effects.call)(_streamManager.default.unmute, {
          _client,
          kind: 'camera',
          _entity: _room
        });
      }
      if (currentScreen && !screenExpected) {
        yield (0, _effects.call)(_streamManager.default.mute, {
          _client,
          kind: 'screen',
          _entity: _room
        });
      } else if (!currentScreen && screenExpected) {
        yield (0, _effects.call)(_streamManager.default.unmute, {
          _client,
          kind: 'screen',
          _entity: _room
        });
      }
      if (camera || audio || screenSharing) {
        yield (0, _effects.call)(localStreamLogic, {
          audio: audioExpected,
          video: cameraExpected,
          screen: screenExpected,
          _client,
          _room
        });
      } else if (clientSource !== 'web' && (camera === false || audio === false || screenSharing === false)) {
        // delay to close the PC
        yield (0, _effects.delay)(2000);
      }

      // due to possible race between, takeEvery and delay
      // ==> if we trigger mute/unmute faster, we lose audio remote
      var currentAudioBis = yield (0, _effects.call)(_streamManager.default.hasAudio, {
        _client,
        _entity: _room
      });
      var currentCameraBis = yield (0, _effects.call)(_streamManager.default.hasCamera, {
        _client,
        _entity: _room
      });
      var currentScreenBis = yield (0, _effects.call)(_streamManager.default.hasScreen, {
        _client,
        _entity: _room
      });
      var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
      var {
        features
      } = room || {};
      yield (0, _effects.call)(waitAfterWS, _room, 'patchRoomJoin');
      yield (0, _effects.call)(_apis.$patchRoomJoin, _room, _client, (features === null || features === void 0 ? void 0 : features.audio) !== false ? currentAudioBis : undefined, (features === null || features === void 0 ? void 0 : features.video) !== false ? currentCameraBis : undefined, (features === null || features === void 0 ? void 0 : features.screenSharing) !== false ? currentScreenBis : undefined, undefined, triggeredBy);
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'patchRoomJoin');
      _callbacks.default.get('onPatchRoomJoinFailed')(_room, audio, camera, screenSharing);
    }
  }();
}
function patchRoomRecordingStatus(_ref14) {
  var {
    _room,
    recordingState
  } = _ref14;
  return function* () {
    logger.log('patchRoomRecordingStatus', {
      _room,
      recordingState
    });
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    if ((0, _isNil.default)(recordingState)) return;
    try {
      yield (0, _effects.call)(_apis.$patchRoomRecording, _room, _client, recordingState);
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'patchRoomRecordingStatus');
      _callbacks.default.get('onPatchRoomRecordingStatusFailed')(_room, recordingState);
    }
  }();
}
function joinRoom(_ref15) {
  var {
    _room,
    audio,
    video
  } = _ref15;
  return function* () {
    logger.log('joinRoom', {
      _room,
      audio,
      video
    });
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
    if (!room) {
      room = yield (0, _effects.call)(getRoom, {
        _room
      });
    }
    if (room) {
      var _room$members, _room$members2;
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      var _device = yield (0, _effects.call)(_callbacks.default.get('getDeviceId'));

      // process the new room
      var waitingMembers = yield (0, _effects.select)(_selectors2.getWaitingRoomMembersByRoomIdSelector, _room);
      var connectedRoomMembers = yield (0, _effects.select)(_selectors2.getConnectedRoomMembersWithoutMyDeviceByRoomIdSelector, _room);
      var {
        isPersistent,
        caller
      } = room;
      var ringbackTone = !isPersistent && (caller === null || caller === void 0 ? void 0 : caller._user) === _user && (waitingMembers === null || waitingMembers === void 0 ? void 0 : waitingMembers.length) === ((_room$members = room.members) === null || _room$members === void 0 ? void 0 : _room$members.length) && ((_room$members2 = room.members) === null || _room$members2 === void 0 ? void 0 : _room$members2.length) > 1;
      _callbacks.default.get('DeviceCallManagerStart')({
        kind: room.isVideoCall ? 'video' : 'audio',
        ringbackTone,
        _room
      });
      try {
        yield (0, _effects.call)(localStreamLogic, {
          audio: true,
          video,
          _client,
          _room
        });
        yield (0, _effects.call)(waitAfterWS, _room, 'joinRoom');
        yield (0, _effects.call)(_apis.$postRoomJoin, _room, _client, audio, video, _device);
        if (connectedRoomMembers.length >= 2) {
          // displayMode will be grid so we unfocus from everything after joining
          yield (0, _effects.put)((0, _actions.clearClientFocus)(_room));
        }
      } catch (e) {
        var _e$response3, _e$response4, _e$response5;
        _callbacks.default.get('DeviceCallManagerStop')({
          _room
        });
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'joinRoom');
        if (e instanceof _axios.AxiosError && (e === null || e === void 0 || (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.status) === 404) {
          yield (0, _effects.put)((0, _actions.removeRoom)(_room));
        } else if (e instanceof _axios.AxiosError && (e === null || e === void 0 || (_e$response4 = e.response) === null || _e$response4 === void 0 || (_e$response4 = _e$response4.data) === null || _e$response4 === void 0 ? void 0 : _e$response4.code) === 'ROOM_ERROR_MAXIMUM_PARTICIPANTS_REACHED') {
          _callbacks.default.get('onRoomJoinMaxMembersReached')({
            room
          });
        } else if (e instanceof _axios.AxiosError && (e === null || e === void 0 || (_e$response5 = e.response) === null || _e$response5 === void 0 || (_e$response5 = _e$response5.data) === null || _e$response5 === void 0 ? void 0 : _e$response5.code) === 'ROOM_ERROR_MAXIMUM_CALLS_REACHED') {
          var _e$response$data$data;
          _callbacks.default.get('onRoomJoinMaxCallsReached')({
            maxCalls: (_e$response$data$data = e.response.data.data) === null || _e$response$data$data === void 0 ? void 0 : _e$response$data$data.maxCalls,
            room
          });
        } else {
          _callbacks.default.get('onRoomJoinFailed')({
            room,
            error: e
          });
        }
      }
    } else {
      _callbacks.default.get('onRoomNotFound')(_room);
    }
  }();
}
function createRoomLogic(_ref16) {
  var {
    name,
    roomType,
    _targets,
    _sourceFeed,
    autoJoin = true,
    destNumbers
  } = _ref16;
  return function* (_uuid) {
    // generate short ID to match creating and created room because room has not been created yet. (only for logging usage)
    var createRoomSagaId = (_uuid = (0, _uuid2.generate)()) === null || _uuid === void 0 ? void 0 : _uuid.substr(-6);
    logger.log("createRoom:".concat(createRoomSagaId), {
      name,
      roomType,
      _targets,
      _sourceFeed,
      autoJoin,
      destNumbers
    });
    var _room;
    try {
      var _config$room5;
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      var roomBody = {
        type: _constants.ROOM_TYPE.AUDIO,
        _client
      };

      // check if maxConcurrencies is not reached
      if (_config.default !== null && _config.default !== void 0 && (_config$room5 = _config.default.room) !== null && _config$room5 !== void 0 && _config$room5.maxConcurrencies) {
        var _config$room6;
        var _currentRoomsByClient = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);
        if ((_currentRoomsByClient === null || _currentRoomsByClient === void 0 ? void 0 : _currentRoomsByClient.length) >= (_config.default === null || _config.default === void 0 || (_config$room6 = _config.default.room) === null || _config$room6 === void 0 ? void 0 : _config$room6.maxConcurrencies)) {
          var _config$room7;
          return _callbacks.default.get('onRoomCreateMaxCallsReached')({
            maxCalls: _config.default === null || _config.default === void 0 || (_config$room7 = _config.default.room) === null || _config$room7 === void 0 ? void 0 : _config$room7.maxConcurrencies
          });
        }
      }
      if ([_constants.ROOM_TYPE.VIDEO, _constants.ROOM_TYPE.AUDIO].includes(roomType)) roomBody.type = roomType;
      if (name) roomBody.name = name;
      if (_sourceFeed) roomBody._feed = _sourceFeed;
      if (_targets !== null && _targets !== void 0 && _targets.length) roomBody._users = _targets;
      if (destNumbers !== null && destNumbers !== void 0 && destNumbers.length) roomBody.destNumbers = destNumbers;

      // in order to test client in SFU or MESH mode
      if (_config.default.debug) {
        var topology = _callbacks.default.get('getTopology')();
        if (['MESH', 'SFU'].includes(topology)) roomBody.topology = topology;
      }
      _callbacks.default.get('vibrate')();
      var response = yield (0, _effects.call)(_apis.$postRoom, roomBody);
      _room = response.data.id;
      logger.log("createRoom:".concat(createRoomSagaId, ":created"), _room);
      var isVideoCall = roomType === _constants.ROOM_TYPE.VIDEO;
      if (autoJoin) {
        var ringbackTone = !!_sourceFeed || !!(_targets !== null && _targets !== void 0 && _targets.length);
        _callbacks.default.get('DeviceCallManagerStart')({
          kind: roomType.toLowerCase(),
          ringbackTone,
          _room
        });
        yield (0, _effects.call)(localStreamLogic, {
          audio: true,
          video: isVideoCall,
          _client,
          _room
        });
      }
      var roomData = yield (0, _effects.call)(_middlewares.roomEnrichment, {
        room: response.data,
        _client,
        _user
      });
      yield* (0, _api.normalizeApiResponse)([roomData], [_schemas.room]);
      yield (0, _effects.put)((0, _actions.newOutgoingRoom)(_room, true, isVideoCall));
      _callbacks.default.get('analyticsLogEvent')('room_start', {
        roomId: _room
      });
      if (autoJoin) {
        yield (0, _effects.call)(joinRoom, {
          _room,
          audio: true,
          video: isVideoCall
        });
      }
      yield (0, _effects.call)(addCurrentRoomsByClientLogic, _room);
    } catch (e) {
      var _e$response6, _e$response7;
      if (autoJoin && _room) {
        _callbacks.default.get('DeviceCallManagerStop')({
          _room
        });
      }
      if ((0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('network.error.timeout'),
          referenceError: 'R12',
          error: e
        }));
      } else if (e instanceof _axios.AxiosError && (e === null || e === void 0 || (_e$response6 = e.response) === null || _e$response6 === void 0 || (_e$response6 = _e$response6.data) === null || _e$response6 === void 0 ? void 0 : _e$response6.code) === 'ROOM_ERROR_MAXIMUM_PARTICIPANTS_REACHED') {
        var _e$response$data$data2, _e$response$data$data3;
        return _callbacks.default.get('onRoomCreateMaxMembersReached')({
          members: (_e$response$data$data2 = e.response.data.data) === null || _e$response$data$data2 === void 0 ? void 0 : _e$response$data$data2.members,
          maxMembers: (_e$response$data$data3 = e.response.data.data) === null || _e$response$data$data3 === void 0 ? void 0 : _e$response$data$data3.maxMembers,
          roomType
        });
      } else if (e instanceof _axios.AxiosError && (e === null || e === void 0 || (_e$response7 = e.response) === null || _e$response7 === void 0 || (_e$response7 = _e$response7.data) === null || _e$response7 === void 0 ? void 0 : _e$response7.code) === 'ROOM_ERROR_MAXIMUM_CALLS_REACHED') {
        var _e$response$data$data4;
        _callbacks.default.get('onRoomCreateMaxCallsReached')({
          maxCalls: (_e$response$data$data4 = e.response.data.data) === null || _e$response$data$data4 === void 0 ? void 0 : _e$response$data$data4.maxCalls
        });
      } else {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'R10',
          error: e
        }));
      }
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'createRoomLogic');
    }
  }();
}
function acceptIncoming(_ref17) {
  var {
    _room,
    audio,
    video,
    autoJoin = true
  } = _ref17;
  return function* () {
    logger.log('acceptIncoming', {
      _room,
      audio,
      video,
      autoJoin
    });
    var ringingRooms = yield (0, _effects.select)(_selectors2.getRingingRoomsSelector);
    var _currentRoomsByClient = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);

    // Do nothing if the room is not ringing or is already joined
    if (!_room || !ringingRooms.includes(_room) || _currentRoomsByClient.includes(_room)) {
      yield (0, _effects.call)(_errorHandler.default.captureMessage, "!_room=".concat(!_room, "; !ringing=").concat(!ringingRooms.includes(_room), "; current=").concat(_currentRoomsByClient.includes(_room)), 'acceptIncomingEmpty');
      return;
    }
    try {
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      if (autoJoin) {
        if (!video) {
          var currentVideo = yield (0, _effects.call)(_streamManager.default.hasCamera, {
            _client,
            _entity: _room
          });
          if (currentVideo) {
            yield (0, _effects.call)(_streamManager.default.mute, {
              _client,
              kind: _constants.ROOM_TYPE.VIDEO.toLowerCase(),
              _entity: _room
            });
          }
        }
        yield (0, _effects.call)(joinRoom, {
          _room,
          audio,
          video
        });
        yield (0, _effects.call)(addCurrentRoomsByClientLogic, _room);
      }
    } catch (e) {
      if (!(0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'R11',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'acceptIncoming');
      } else {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('network.error.timeout'),
          referenceError: 'R13',
          error: e
        }));
      }
    }
    yield (0, _effects.call)(ringingLogic, {
      _room,
      enable: false
    });
  }();
}
function rejectIncoming(_ref18) {
  var {
    _room,
    silent
  } = _ref18;
  return function* () {
    logger.log('rejectIncoming', {
      _room,
      silent
    });
    yield (0, _effects.call)(ringingLogic, {
      _room,
      enable: false
    });
    if (!silent) {
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      try {
        yield (0, _effects.call)(_apis.$refuseRoom, _room, _client);
      } catch (e) {
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'rejectIncoming');
      }
    }
  }();
}
function leaveRoom(_ref19) {
  var {
    _room,
    silent
  } = _ref19;
  return function* () {
    logger.log('leaveRoom', {
      _room
    });

    // clear stream asap
    try {
      _peerManager.default.removePeersByEntity(_room);
    } catch (e) {
      if (!silent) yield (0, _effects.call)(_errorHandler.default.captureException, e, 'leaveRoomPeer');
    }
    try {
      _streamManager.default.removeStreamsByEntity(_room);
    } catch (e) {
      if (!silent) yield (0, _effects.call)(_errorHandler.default.captureException, e, 'leaveRoomStream');
    }
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    var _user = yield (0, _effects.select)(_selectors.getUserId);
    var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
    try {
      yield (0, _effects.fork)(handleWsRoomEnd, {
        payload: room
      });
      yield (0, _effects.call)(ringingLogic, {
        _room,
        enable: false
      });
      if (!silent) _callbacks.default.get('analyticsLogEvent')('room_leave', {
        roomId: _room
      });
      yield (0, _effects.call)(removeCurrentRoomsByUserLogic, _room);
      yield (0, _effects.call)(_apis.$postRoomLeave, _room, _user, _client);
    } catch (e) {
      var _e$response8;
      // silent leave
      if ((room === null || room === void 0 ? void 0 : room.isPersistent) === false) yield (0, _effects.put)((0, _actions.removeRoom)(_room));
      if (!silent && e instanceof _axios.AxiosError && (e === null || e === void 0 || (_e$response8 = e.response) === null || _e$response8 === void 0 ? void 0 : _e$response8.status) !== 404) {
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'leaveRoom');
      }
    }
  }();
}
function updateMember(_ref20) {
  var {
    payload: {
      token,
      _client,
      _entity,
      state
    }
  } = _ref20;
  return function* () {
    var _rooms = yield (0, _effects.select)(_selectors2._roomsSelector);
    if (_rooms.includes(_entity)) {
      logger.log('updateMember ', {
        token,
        _client,
        _entity,
        state
      });
      var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _entity);
      var _myClient = yield (0, _effects.select)(_selectors._currentClientSelector);
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      if (!room) return;
      var _currentByClientRooms = yield (0, _effects.select)(_selectors2.getCurrentByClientRoomsSelector);
      if (_currentByClientRooms.includes(_entity)) {
        // mute or Unmute only if room was joined
        if (holdRoomStates[_entity]) {
          _streamManager.default.muteAllRemoteTracks({
            _entity,
            dispatchUpdate: false
          });
        } else {
          _streamManager.default.unmuteAllRemoteTracks({
            _entity,
            dispatchUpdate: false
          });
        }
      }
      var roomEnriched = yield (0, _effects.call)(_middlewares.roomEnrichment, {
        room,
        _client: _myClient,
        _user
      });
      yield* (0, _api.normalizeApiResponse)([roomEnriched], [_schemas.room]);
    }
  }();
}
function setFocusOnClient(_ref21) {
  var {
    _room,
    _client,
    isUserEvent = false
  } = _ref21;
  return function* (_room$focusOn) {
    logger.log('setFocusOnClient ', {
      _room,
      _client,
      isUserEvent
    });
    var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
    var _focusClient = _streamManager.default.getFocus(_room);
    if (!room || !_client || (room === null || room === void 0 || (_room$focusOn = room.focusOn) === null || _room$focusOn === void 0 ? void 0 : _room$focusOn._client) === _client && _focusClient === _client) {
      return;
    }
    yield (0, _effects.put)((0, _actions3.websocketSend)({
      code: 'ROOM_CLIENT_FOCUS',
      payload: {
        _room,
        _client
      }
    }));

    // Give the streamManager an disEngageable focus behavior
    // and set client focus from user request directly on room
    if (isUserEvent) {
      room.focusOn = yield (0, _effects.select)(_selectors2.getRoomMemberByClientIdSelector, _room, _client);
    } else {
      _streamManager.default.setFocus({
        _entity: _room,
        _client
      });
    }
    var _user = yield (0, _effects.select)(_selectors.getUserId);
    var _myClient = yield (0, _effects.select)(_selectors._currentClientSelector);

    // Update room Object with new values
    room.displayMode = _constants.ROOM_DISPLAY_MODE.FULL_SCREEN;
    room.forcedDisplayMode = true;
    var roomEnriched = yield (0, _effects.call)(_middlewares.roomEnrichment, {
      room,
      _client: _myClient,
      _user
    });
    yield* (0, _api.normalizeApiResponse)([roomEnriched], [_schemas.room]);
  }();
}
function clearFocusFromAllClient(_ref22) {
  var {
    _room,
    isUserEvent
  } = _ref22;
  return function* (_room$focusOn2) {
    logger.log('clearFocusFromAllClient ', {
      _room
    });
    var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
    var _focusClient = _streamManager.default.getFocus(_room);
    if (!_room || !room || !(room !== null && room !== void 0 && (_room$focusOn2 = room.focusOn) !== null && _room$focusOn2 !== void 0 && _room$focusOn2._client) && !_focusClient) return;
    yield (0, _effects.put)((0, _actions3.websocketSend)({
      code: 'ROOM_CLIENT_FOCUS',
      payload: {
        _room,
        _client: null
      }
    }));
    if (!isUserEvent) {
      _streamManager.default.setFocus({
        _entity: _room,
        _client: null
      });
    }

    // Update room Object with new values
    room.focusOn = null;
    room.displayMode = _constants.ROOM_DISPLAY_MODE.GRID;
    room.forcedDisplayMode = true;
    var _user = yield (0, _effects.select)(_selectors.getUserId);
    var _myClient = yield (0, _effects.select)(_selectors._currentClientSelector);
    var roomEnriched = yield (0, _effects.call)(_middlewares.roomEnrichment, {
      room,
      _client: _myClient,
      _user
    });
    yield* (0, _api.normalizeApiResponse)([roomEnriched], [_schemas.room]);
  }();
}
function scheduleIncoming(_ref23) {
  var {
    _room
  } = _ref23;
  return function* () {
    var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
    logger.log('scheduleIncoming ', {
      _room,
      room
    });
    try {
      yield (0, _effects.call)(_apis5.$sendPushNotifToMe, {
        title: _i18n.default.translate('room.reminder.title'),
        message: _i18n.default.translate('room.reminder.call', {
          fullname: room.caller.fullname
        }),
        sendAt: new Date(Date.now() + _config.default.reminder.roomDelay).toISOString(),
        data: {
          _user: room.caller._user
        },
        url: undefined
      });
      yield (0, _effects.call)(rejectIncoming, {
        _room,
        silent: true
      });
    } catch (e) {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'R3',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'scheduleIncoming');
    }
  }();
}
function fastReplyToCaller(_ref24) {
  var {
    _room,
    message
  } = _ref24;
  return function* () {
    var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
    logger.log('fastReplyToCaller ', {
      _room,
      room,
      message
    });
    try {
      var {
        data: {
          _feed = undefined
        } = {}
      } = yield (0, _effects.call)(_apis2.$postAnchor, room.caller._user);
      if (_feed) {
        var feedItem = {
          id: (0, _uuid2.generate)(),
          content: "\uD83D\uDCAC ".concat(message)
        };
        yield (0, _effects.call)(_apis4.$postFeedItem, _feed, feedItem);
        yield (0, _effects.call)(rejectIncoming, {
          _room
        });
      }
    } catch (e) {
      logger.warn('fastReplyToCaller', e);
    }
  }();
}
function deleteRoom(_ref25) {
  var {
    _room
  } = _ref25;
  return function* () {
    logger.log('deleteRoom', {
      _room
    });
    try {
      yield (0, _effects.call)(_apis.$deleteRoom, _room);
      _callbacks.default.get('analyticsLogEvent')('room_delete', {
        roomId: _room
      });
    } catch (e) {
      if ((0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('network.error.timeout'),
          referenceError: 'R14',
          error: e
        }));
      } else {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'R6',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'deleteRoom');
      }
    }
  }();
}
function patchRoom(_ref26) {
  var {
    _room,
    room
  } = _ref26;
  return function* () {
    logger.log('patchRoom', {
      room,
      _room
    });
    try {
      if (!room || !_room) return;
      var roomToUpdate = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
      var roomUpdated = _objectSpread(_objectSpread({}, roomToUpdate), room);
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      var roomEnriched = yield (0, _effects.call)(_middlewares.roomEnrichment, {
        room: roomUpdated,
        _client,
        _user
      });
      yield* (0, _api.normalizeApiResponse)([roomEnriched], [_schemas.roomPatch]);
      yield (0, _effects.call)(_apis.$patchRoom, _room, room);
      _callbacks.default.get('analyticsLogEvent')('room_patch', {
        roomId: _room
      });
    } catch (e) {
      if ((0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('network.error.timeout'),
          referenceError: 'R15',
          error: e
        }));
      } else {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'R4',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'patchRoom');
      }
    }
  }();
}
function kickFromRoom(_ref27) {
  var {
    _room,
    _users
  } = _ref27;
  return function* () {
    logger.log('kickFromRoom', {
      _room,
      _users
    });
    try {
      if (_users.length > 0) {
        yield (0, _effects.call)(_apis.$postRoomKicks, _room, _users);
      }
      _callbacks.default.get('analyticsLogEvent')('room_kick_post', {
        roomId: _room,
        userIds: _users
      });
    } catch (e) {
      if ((0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('network.error.timeout'),
          referenceError: 'R18',
          error: e
        }));
      }
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'R8',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'kickFromRoom');
    }
  }();
}
function quitBoringRoom(_ref28) {
  var {
    _room
  } = _ref28;
  return function* () {
    logger.log('quitBoringRoom', {
      _room
    });
    try {
      var _user = yield (0, _effects.select)(_selectors.getUserId);
      yield (0, _effects.call)(kickFromRoom, {
        _room,
        _users: [_user]
      });
    } catch (e) {
      logger.warn('quitBoringRoom', e);
    }
  }();
}
function editRoomInvites(_ref29) {
  var {
    _room,
    _removedUsers,
    _addedUsers
  } = _ref29;
  return function* () {
    logger.log('editRoomInvites', {
      _room,
      _removedUsers,
      _addedUsers
    });
    try {
      if (_addedUsers.length > 0) {
        yield (0, _effects.call)(inviteToRoom, {
          _room,
          _users: _addedUsers
        });
      }
      if (_removedUsers.length > 0) {
        yield (0, _effects.call)(kickFromRoom, {
          _room,
          _users: _removedUsers
        });
      }
    } catch (e) {
      if ((0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('network.error.timeout'),
          referenceError: 'R16',
          error: e
        }));
      } else {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'R9',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'editRoomInvites');
      }
    }
  }();
}
function inviteToRoom(_ref30) {
  var {
    _room,
    _users
  } = _ref30;
  return function* () {
    logger.log('inviteToRoom', {
      _room,
      _users
    });
    try {
      if (_users.length > 0) {
        yield (0, _effects.call)(_apis.$postRoomInvites, _room, _users);
      }
      _callbacks.default.get('analyticsLogEvent')('room_invite_user', {
        roomId: _room,
        userIds: _users
      });
    } catch (e) {
      if ((0, _middlewares2.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('network.error.timeout'),
          referenceError: 'R17',
          error: e
        }));
      } else {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'R7',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'inviteToRoom');
      }
    }
  }();
}
function handleTakeoff(_ref31) {
  var {
    payload: {
      _room,
      _client
    }
  } = _ref31;
  return function* () {
    logger.log('handleTakeoff', {
      _room,
      _client
    });
    var _myClient = yield (0, _effects.select)(_selectors._currentClientSelector);
    if (_client !== _myClient) {
      yield (0, _effects.call)(ringingLogic, {
        _room,
        enable: false
      });
      yield (0, _effects.call)(addCurrentRoomsByUserLogic, _room);
    }
  }();
}
function handleMissed(_ref32) {
  var {
    payload: {
      _room
    }
  } = _ref32;
  return function* () {
    logger.log('handleHangup', {
      _room
    });
    yield (0, _effects.call)(ringingLogic, {
      _room,
      enable: false
    });
  }();
}
function handleHDChange(_ref33) {
  var {
    isHDEnabled,
    _room
  } = _ref33;
  return function* (_room$focusOn3) {
    logger.log('handleHDChange', {
      isHDEnabled
    });
    _config.default.setConfig({
      webRTC: {
        HDEnabled: isHDEnabled
      }
    });
    if (!_room) return;
    var room = yield (0, _effects.select)(_selectors2.getRoomByIdSelector, _room);
    if (!(room !== null && room !== void 0 && (_room$focusOn3 = room.focusOn) !== null && _room$focusOn3 !== void 0 && _room$focusOn3._client)) return;
    // Reprocess ROOM
    var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
    var _user = yield (0, _effects.select)(_selectors.getUserId);
    var roomEnriched = yield (0, _effects.call)(_middlewares.roomEnrichment, {
      room,
      _client,
      _user
    });
    yield* (0, _api.normalizeApiResponse)([roomEnriched], [_schemas.room]);
    // Reset the room focus
    yield (0, _effects.put)((0, _actions3.websocketSend)({
      code: 'ROOM_CLIENT_FOCUS',
      payload: {
        _room,
        _client: null
      }
    }));
    yield (0, _effects.delay)(100);
    // Request the back to resend PC HD
    yield (0, _effects.put)((0, _actions3.websocketSend)({
      code: 'ROOM_CLIENT_FOCUS',
      payload: {
        _room,
        _client: room.focusOn._client
      }
    }));
  }();
}
function sendDTMF(_ref34) {
  var {
    _room,
    digit
  } = _ref34;
  return function* () {
    try {
      yield (0, _effects.call)(_apis.$sendDTMF, _room, digit);
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'sendDTMF');
    }
  }();
}
function transferRoom(_ref35) {
  var {
    _room,
    _destRoom,
    destNumber,
    _destUser
  } = _ref35;
  return function* () {
    logger.log('transferRoom', {
      _room,
      _destRoom,
      destNumber,
      _destUser
    });
    try {
      yield (0, _effects.call)(_apis.$forwardRoom, _room, _destRoom, destNumber, _destUser);
      _callbacks.default.get('onForwardRoomRequested')({
        _room,
        _destRoom,
        destNumber,
        _destUser
      });
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'transferRoom');
      _callbacks.default.get('onForwardRoomFailed')({
        _room,
        _destRoom,
        destNumber,
        _destUser
      });
    }
  }();
}
function handleWsRoomHold(_ref36) {
  var {
    payload: {
      _room,
      _client,
      hold
    }
  } = _ref36;
  return function* () {
    logger.log('handleWsRoomHold', {
      _room,
      _client,
      hold
    });
    var _myClient = yield (0, _effects.select)(_selectors._currentClientSelector);
    if (!_client || _client === _myClient) {
      yield (0, _effects.call)(holdRoomLogic, {
        _room,
        hold,
        triggeredBy: 'WS_ROOM_HOLD'
      });
    }
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.debounce)(_constants2.sagasTiming, [types.REQUEST_GET_ROOMS, _types3.WS_CONNECT, _types2.REQUEST_LOGIN_SUCCESS], getRooms), (0, _sagas.takeEvery)(types.WS_ROOM_UPDATE, handleWsRoomUpdate), (0, _sagas.takeLatest)(types.REQUEST_GET_ROOM, getRoom), (0, _sagas.takeEvery)(types.ROOM_INCOMING_ACCEPT, acceptIncoming), (0, _sagas.takeEvery)(types.ROOM_INCOMING_REJECT, rejectIncoming), (0, _sagas.takeEvery)(types.ROOM_INCOMING_SCHEDULE, scheduleIncoming), (0, _sagas.takeEvery)(types.ROOM_INCOMING_MESSAGE, fastReplyToCaller), (0, _sagas.takeEvery)(types.REQUEST_POST_ROOM_LEAVE, leaveRoom), (0, _sagas.takeEvery)(types.WS_ROOM_INCOMING, wsRoomIncoming), (0, _sagas.takeEvery)(types.WS_ROOM_DELETE, handleWsRoomDelete), (0, _sagas.takeEvery)(types.WS_ROOM_HOLD, handleWsRoomHold), (0, _sagas.throttle)(1000, types.ROOM_START, createRoomLogic),
  // throttle to prevent multiple call press button
  (0, _sagas.throttle)(1000, types.REQUEST_POST_ROOM_JOIN, joinRoom),
  // throttle to prevent multiple answer press button
  (0, _sagas.takeEvery)(types.REQUEST_PATCH_ROOM_JOIN, patchRoomJoin), (0, _sagas.takeEvery)(types.REQUEST_PATCH_ROOM_RECORDING, patchRoomRecordingStatus), (0, _sagas.takeEvery)(types.REQUEST_ROOM_HOLD, holdRoomLogic), (0, _sagas.takeLatest)(types.SET_CLIENT_FOCUS, setFocusOnClient), (0, _sagas.takeLatest)(types.CLEAR_CLIENT_FOCUS, clearFocusFromAllClient), (0, _sagas.takeEvery)(types.REQUEST_PATCH_ROOM, patchRoom), (0, _sagas.takeEvery)(types.WS_ROOM_TAKEOFF, handleTakeoff), (0, _sagas.takeEvery)(types.REQUEST_DELETE_ROOM, deleteRoom), (0, _sagas.takeEvery)(types.WS_ROOM_MISSED, handleMissed), (0, _sagas.takeLatest)(types.REQUEST_POST_ROOM_KICKS, kickFromRoom), (0, _sagas.takeLatest)(types.REQUEST_POST_ROOM_QUIT, quitBoringRoom), (0, _sagas.takeLatest)(types.REQUEST_EDIT_ROOM_INVITES, editRoomInvites), (0, _sagas.takeLatest)(types.REQUEST_POST_ROOM_INVITES, inviteToRoom), (0, _sagas.takeLatest)(types.SET_HD_ENABLED, handleHDChange), (0, _sagas.takeEvery)(types.ROOM_SEND_DTMF, sendDTMF), (0, _sagas.takeEvery)(types.REQUEST_FORWARD_ROOM, transferRoom)]);
}

// DO not remove !
// if you don't do that, updateMember will not be exported correctly and the root saga too
// could be a bug of babel ? I think so !
module.exports = exports.default;
module.exports.updateMember = updateMember;